import { ReactElement } from 'react';
import { Button, ModalOverlay } from '@flos/react-ui';

import styles from './DeleteGiftCardModal.module.css';

/* ==================================== Local Types ==================================== */
type TDeleteGiftCardModal = (props: { onSubmit: () => void; onDismiss: () => void }) => ReactElement;

/* ==================================== Main Component ==================================== */
const DeleteGiftCardModal: TDeleteGiftCardModal = ({ onSubmit, onDismiss }) => {
  return (
    <ModalOverlay className={styles['root']} isOpen>
      <div className={styles['content']}>
        <div className={styles['content-title']}>Delete GiftCard</div>
        <div className={styles['content-text']}>Are you sure, you want to delete this gift card?</div>
        <div className={styles['content-buttons-container']}>
          <Button theme="secondary" onClick={onSubmit}>
            Yes, Delete
          </Button>
          <Button onClick={onDismiss}>Cancel</Button>
        </div>
      </div>
    </ModalOverlay>
  );
};

export default DeleteGiftCardModal;
